export function setUnitSelected(unitSelected) {
  return {
    type: '@unitSelected/SET',
    payload: { unitSelected },
  }
}
